import Box from "@mui/material/Box";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export interface ScopeOption<T extends string> {
  value: T;
  label: string;
  /** A count that needs attention ("4" pending), drawn as a small badge. */
  badge?: number;
}

interface ScopeToggleProps<T extends string> {
  value: T;
  options: ScopeOption<T>[];
  onChange: (value: T) => void;
  "aria-label": string;
}

/** Which slice of a list you're looking at ("All lists" / "My lists"), left of a filter bar's search. */
export default function ScopeToggle<T extends string>({ value, options, onChange, ...rest }: ScopeToggleProps<T>) {
  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      onChange={(_, next: T | null) => next && onChange(next)}
      aria-label={rest["aria-label"]}
    >
      {options.map((o) => (
        <ToggleButton key={o.value} value={o.value} sx={{ px: 1.5 }}>
          {o.label}
          {!!o.badge && (
            <Box
              component="span"
              sx={{
                ml: 0.75,
                px: 0.75,
                minWidth: 18,
                lineHeight: "18px",
                borderRadius: 999,
                fontSize: "0.6875rem",
                fontWeight: 600,
                bgcolor: "warning.main",
                color: "warning.contrastText",
              }}
            >
              {o.badge}
            </Box>
          )}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
